<template>
    <div class="login_button" :class="{logged_in}">
        <span class="icon" v-if="!logged_in"><img src="../assets/images/login.svg" alt="login"></span>
        <span>{{logged_in ? 'ログイン中' : 'ログイン'}}</span>
    </div>
</template>

<script>
    import { mapState } from 'vuex'
    export default {
        name: "LoginButton",
        computed: {
            ...mapState(["user_data"]),
            logged_in: _this => _this.user_data.id !== -1
        }
    }
</script>

<style scoped lang="scss">
    .login_button{
        user-select: none;
        color: #826E67;
        font-size: 15px;
        padding: 0 0.5rem;
        width: 110px;
        height: 45px;
        display: flex;
        background-color: white;
        justify-content: center;
        align-items: center;
        border: solid 2px #826E67;
        border-radius: 5px;
        cursor: pointer;
        box-sizing: border-box;
        &.logged_in{
            color: white;
            background-color: #826E67;
        }
        &:hover{
            opacity: 0.8;
        }
        .icon{
            width: 0.75rem;
            position: relative;
            top: -2px;
            margin-right: 0.5rem;
            img{
                vertical-align: middle;
            }
        }
    }

    @media screen and (max-width:639px) {
        .login_button{
            font-size: 11px;
            padding: 2px 5px 0;
            width: 65px;
            border: solid 1px #826E67;
            flex-direction: column;
            &.logged_in{
                font-size: 10px;
            }
            .icon{
                width: 7px;
                top: 0;
                margin: 0;
                img{
                    width: 7px;
                }
            }
        }
    }
</style>
